import React from "react";
import { Box } from "@mui/material";
import { fieldLabels } from "../../../constants/invoiceData/FieldLabels";

interface ReusableTypographyProps {
  label: string;
  value: string;
  styles?: React.CSSProperties;
}

const ReusableTypography: React.FC<ReusableTypographyProps> = ({
  label,
  value,
  styles,
}) => (
  <Box
    component="div"
    sx={{
      fontSize: "10px",
      lineHeight: 2,
      fontFamily: "Inter",
      paddingLeft: "3px",
      ...styles,
    }}
  >
    <span style={{ fontSize: "10px", fontWeight: 500 }}>{label}: </span> {value}
  </Box>
);

interface InvoiceDetailsProps {
  data: Record<string, string>;
  rowStyles?: React.CSSProperties;
}

const InvoiceDetails: React.FC<InvoiceDetailsProps> = ({ data, rowStyles }) => {
  const entries = Object.entries(data);
  return (
    <Box>
      {entries.map(([key, value], index) => (
        <ReusableTypography
          key={index}
          label={fieldLabels[key] || key}
          value={value}
          styles={index !== entries.length - 1 ? rowStyles : {}}
        />
      ))}
    </Box>
  );
};

export default InvoiceDetails;
